export class QueryCostDataResponse {
    'records';
    'totalCount';
    'totalUniqueResources';
    'resourceCount';
    'nextToken';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "records",
            "baseName": "records",
            "type": "Array<CostDataRecord>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "totalUniqueResources",
            "baseName": "totalUniqueResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "resourceCount",
            "baseName": "resourceCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QueryCostDataResponse.attributeTypeMap;
    }
    constructor() {
    }
}
